// ABOUTME: SPEC-46 Rev 7 — the ONLY module that touches @stripe/stripe-js, memoised per key.
// ABOUTME: Isolated so every test can mock it: the real loader injects a script tag into <head>.
//
// Stripe.js must be loaded from js.stripe.com at runtime and never bundled — that is a PCI
// requirement, not a preference, so the app cannot vendor it. `loadStripe` injects the tag on
// first call and resolves once it is ready.
//
// Two reasons this is its own file rather than an import inside the overlay:
//   1. Tests. A jsdom test that reached the real loader would try to fetch a remote script; every
//      suite mocks this one module instead.
//   2. Failure is a real state, not an exception. Ad blockers and offline guests make
//      `loadStripe` resolve to null or reject, and the overlay has to render something honest
//      rather than an empty panel. Returning null is that signal.

import { loadStripe } from '@stripe/stripe-js';

const cache = new Map();

/**
 * Resolve the Stripe client for a publishable key, or null when it cannot be loaded.
 * Memoised per key: mounting the panel twice must not inject the script twice.
 * @param {string} publishableKey
 * @returns {Promise<any|null>}
 */
export function getStripe(publishableKey) {
  if (!publishableKey) return Promise.resolve(null);
  if (!cache.has(publishableKey)) {
    const pending = Promise.resolve()
      .then(() => loadStripe(publishableKey))
      .catch(() => null);
    cache.set(publishableKey, pending);
  }
  return cache.get(publishableKey);
}

/** Test seam only — the memo would otherwise leak a mocked client between cases. */
export function resetStripeCache() {
  cache.clear();
}
